import { StateCreator } from 'zustand'
import { Transaction } from '../types'

export interface TransactionsSlice {
  transactions: Transaction[]
  addTransaction: (transaction: Transaction) => void
  setTransactions: (transactions: Transaction[]) => void
}

export const createTransactionsSlice: StateCreator<TransactionsSlice> = (
  set,
) => ({
  transactions: [],
  addTransaction: (transaction) =>
    set((state) => ({ transactions: [...state.transactions, transaction] })),
  setTransactions: (transactions) => set({ transactions }),
})
